import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import api from "../api/client.js";
import { useI18n } from "../i18n/I18nContext.jsx";

export default function DepartmentForm({ department, onClose, onSuccess }) {
  const { t } = useI18n();
  const isEdit = !!department;

  const [formData, setFormData] = useState({
    name: "",
    cug_number: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (department) {
      setFormData({
        name: department.name || "",
        cug_number: department.cug_number || "",
      });
    }
  }, [department]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (isEdit) {
        await api.put(`/departments/${department.id}/`, formData);
      } else {
        await api.post("/departments/", formData);
      }
      onSuccess();
    } catch (err) {
      console.error("DepartmentForm error:", err);
      const msg = err.response?.data?.detail || "Failed to save department.";
      if (typeof err.response?.data === 'object' && err.response?.data?.name) {
          setError(err.response.data.name[0]);
      } else {
          setError(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h2 style={{ margin: 0 }}>{isEdit ? "Edit Department" : "Add Department"}</h2>
          <button className="btn btn-outline" style={{ padding: "4px 8px" }} onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit} className="form-grid">
          {error && (
            <div className="alert alert-error" style={{ gridColumn: "1 / -1" }}>
              {error}
            </div>
          )}

          <div className="form-group" style={{ gridColumn: "1 / -1" }}>
            <label>Department Name *</label>
            <input
              type="text"
              name="name"
              required
              placeholder="e.g. Engineering, Revenue"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group" style={{ gridColumn: "1 / -1" }}>
            <label>CUG Number (HOD)</label>
            <input
              type="tel"
              name="cug_number"
              inputMode="numeric"
              pattern="[0-9]{10}"
              maxLength={10}
              placeholder="10-digit HOD CUG mobile"
              value={formData.cug_number}
              onChange={handleChange}
            />
            <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>
              The Department Head's CUG number. A login account is auto-created with this number.
            </div>
          </div>

          <div className="modal-actions" style={{ gridColumn: "1 / -1" }}>
            <button type="button" className="btn btn-outline" onClick={onClose}>
              {t("cancel")}
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? t("loading") : t("save")}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
